import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const StepChooseStationWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "step-choose-station",
})``;
